import React from 'react'
import styled from 'styled-components'
import { usePageMeta } from '../hooks/usePageMeta'
import { useDomain } from '../hooks/useDomain'
import { useConfig } from '../hooks/useConfig'

const Wrapper = styled.div`
    text-align: center;
    max-width: 500px;
    margin: 0 auto;
    padding: 20px;
`

const LegalNotice = () => {
    const domain = useDomain()
    const { config } = useConfig(domain)
    usePageMeta(
        config && `${config?.name} | Legal Notice`,
        'Legal Notice for microsites operated by GSSNHR Records'
    )

    return (
        <Wrapper>
            <h1>Legal Notice</h1>
            <p>
                Service provided by:
                <br />
                Thilo Ilg
                <br />
                Werrastraße 27
                <br />
                60486 Frankfurt am Main
                <br />
                Germany
                <br />
                Email: contact@gssnhr.com
            </p>

            <h3>Responsible for Content (§ 55 RStV)</h3>
            <p>Thilo Ilg, address as above.</p>

            <h3>Purpose of Service</h3>
            <p>
                GSSNHR operates promotional microsites on artist-specific
                domains to provide a central linking hub for their official
                releases. Domains are acquired solely for this non-commercial,
                supportive purpose and are held in trust for the respective
                artists or right holders.
            </p>

            <h3>Domain Policy</h3>
            <p>
                Artists or legitimate right holders may request the transfer of
                a domain registered by GSSNHR at any time. Upon proof of
                entitlement, the domain will be transferred free of charge to a
                registrar account of their choice. GSSNHR waives all claims to
                compensation for such transfers.
            </p>

            <h3>Disclaimer</h3>
            <p>
                All release information, artwork, audio previews and outbound
                links are provided by the respective artists, labels or
                distribution partners. GSSNHR assumes no liability for the
                accuracy, completeness or timeliness of this content. The
                responsibility lies exclusively with the rights holders.
            </p>

            <h3>Liability for Links</h3>
            <p>
                External links are checked at the time of linking. Continuous
                monitoring is unreasonable without concrete evidence of a legal
                violation. Upon notification of infringements such links will be
                removed immediately. The operators of linked pages are solely
                responsible for their content.
            </p>

            <h3>Intellectual Property</h3>
            <p>
                All trademarks, logos and copyrights remain the property of
                their respective owners. Any reproduction or use beyond the
                scope of statutory exceptions requires prior written consent
                from the rights holder.
            </p>

            <h3>Spotify Integration</h3>
            <p>
                This site uses the Spotify API. It is neither endorsed,
                certified nor otherwise approved by Spotify. “Spotify” is a
                registered trademark of Spotify AB.
            </p>

            <h3>Limitation of Liability</h3>
            <p>
                The information on these pages is provided “as is” without any
                express or implied warranty. GSSNHR shall not be liable for
                direct, indirect or consequential damages arising from the use
                of this site except in cases of intentional misconduct or gross
                negligence.
            </p>

            <h3>Data Protection</h3>
            <p>
                Visiting this website is possible without submitting personal
                data. Where personal data is collected, it is provided
                voluntarily and processed in accordance with Art. 6 GDPR. Data
                will not be shared with third parties without explicit consent.
                Users have the right to access, rectify or erase their data at
                any time.
            </p>

            <h3>Dispute Resolution</h3>
            <p>
                The EU Commission provides a platform for online dispute
                resolution: https://ec.europa.eu/consumers/odr. We are neither
                obliged nor willing to participate in a dispute resolution
                procedure before a consumer arbitration board.
            </p>
        </Wrapper>
    )
}

export default LegalNotice
